export default class Row {
  constructor(view) {
    this.view = view;
    this.view.visible = false;
  }

  show() {
    createjs.Tween.get(this.view)
      .to({ visible: true, alpha: 0 })
      .to({ alpha: 1 }, 300);
  }

  hide() {
    this.view.visible = false;
  }
}



// WEBPACK FOOTER //
// ../base/js/display/Row.js